<template>
  <h1>Arbeitsboxen</h1>
    <div class="boxes">
      <select v-model="selectedSurvey" @change="onSurveySelected" >
        <option v-for="survey in surveys" :key="survey.id" :data-title="survey.title" :value="survey.id" >{{ survey.title }}</option>
      </select>
    </div>
  <h1>{{ boxTitle }}</h1>
  <div class="results">
    <ResultElement v-for="result in results" :key="result.id" :result="result" />
  </div>
</template>

<script>
import ResultElement from '@/components/ResultElement.vue'
import ApiService from '@/services/ApiService.js'

export default {
  name: 'Results',
  components: {
    ResultElement
  },
  data() {
    return {
      results: null,
      surveys: null,
      boxTitle: "Auswertung"
    }
  },
  created() {
    if(!localStorage.username || !localStorage.password){
      alert("Bitte Logindaten angeben.");
      return
    }
    this.getSurveys();
    this.getResults(180);
  },
  methods:{
    getResults: function(sid){
      ApiService.getResults(sid, localStorage.username, localStorage.password)
          .then(response => {
            console.log("error:"+response.data.error);
            if(response.data.error == 200){
              this.results = response.data.results
            }else if(response.data.error == 401){
              alert("Login nicht korrekt oder keine Berechtigung.");
            }
          })
          .catch(error => {
            console.log(error)
          });
    },
    getSurveys: function(){
      ApiService.getSurveys()
          .then(response => {
            console.log("error surv "+response.data.error);
            if(response.data.error == 0){
              this.surveys = response.data.surveys;
            }else if(response.data.error == 401){
              alert("Login nicht korrekt oder keine Berechtigung.");
            }
          })
          .catch(error => {
            console.log(error)
          });
    },
    onSurveySelected: function(event){
      if(event.target.options.selectedIndex > -1) {
        console.log(event.target.options[event.target.options.selectedIndex].value);
        this.getResults(event.target.options[event.target.options.selectedIndex].value);
        this.boxTitle = "Auswertung - "+event.target.options[event.target.options.selectedIndex].dataset.title;
      }
    }
  }
}
</script>

<style scoped>
.results {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
